export function amsterdamDay(time = Date.now()) {
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Amsterdam' }).format(new Date(time));
}

export function activeSessions(sessions, time = Date.now()) {
  return sessions.filter(session => {
    const elapsed = time - new Date(session.lastPassing).getTime();
    return elapsed >= 0 && elapsed < 5 * 60_000;
  });
}
